module.exports = __webpack_public_path__ + "img/what-we-can-do-mobile.52fd7d48.png";